<template>
    <div>
        <div class="form-horizontal">

            <form-input :form="form" property="approved">
                <input type="checkbox" v-model="form.approved">
            </form-input>

            <div v-if="form.user_id == null">
                <form-input :form="form" property="user_name"></form-input>
                <form-input :form="form" property="user_email"></form-input>
            </div>
            <div v-else>
                <form-input :form="form" property="user_id">
                    <select3 :value="form.user" @input="changeUser"  :value-key="`name`" data-url="/api/users" ></select3>
                </form-input>
            </div>

            <form-input :form="form" property="text">
                <textarea v-model="form.text" class="form-control" cols="10" rows="5"></textarea>
            </form-input>

            <div class="form-group m-form__group row">
                <label class="col-lg-3 col-form-label">Created at</label>

                <div class="col-md-9">
                    {{ form.created_at }}
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import Model from 'lib/Model';
import Form from 'lib/Form';

export default {
    mixins: [Model],
    data() {
        return {
            method: '/api/comments',
            form: new Form(() => {
                return {
                    approved: false,
                    user_name: null,
                    user_email: null,
                    user_id: null,
                    users: null,
                    text: null,
                };
            })
        };
    },
    methods:{
        changeUser(user)
        {
            this.form.user_id = user && user.id;
            this.form.user = user;
        }
    },
    mounted() {

    },
};
</script>



// WEBPACK FOOTER //
// resources/js/forms/comments/BlogComment.vue